import { FOOTER_MJML } from "../common/footer";
import { PRODUCT_HEADER } from "../common/header";

export const productReminder = `
<mjml>
  <mj-head>
    <mj-title>Don't Miss Out: Your Action Needed</mj-title>
    <mj-preview>A quick reminder about your {{product_name}} subscription</mj-preview>
    <mj-attributes>
      <mj-all font-family="Arial, sans-serif" />
      <mj-text font-size="16px" color="#333333" line-height="1.5" />
    </mj-attributes>
    <mj-style>
      .countdown-box { 
        border: 1px solid #e0e0e0; 
        border-radius: 8px; 
        background-color: #f9f9f9; 
      }
      .highlight-text {
        color: #1890ff;
        font-weight: bold;
      }
      .feature-container {
        border-radius: 8px;
        overflow: hidden;
      }
    </mj-style>
  </mj-head>
  <mj-body background-color="#f5f5f5">
    ${PRODUCT_HEADER("Quick Reminder", "Your action is needed")}
    
    <mj-section background-color="#ffffff" padding="30px 0" border-radius="8px">
      <mj-column>
        <mj-text font-size="22px" color="#333333" font-family="Arial, sans-serif">Hello {{first_name}},</mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">
          This is a friendly reminder about your {{product_name}}. We noticed you haven't {{action_needed}} yet, and we wanted to make sure you don't miss out on the benefits.
        </mj-text>
      </mj-column>
    </mj-section>
    
    <!-- Countdown timer section -->
    <mj-section background-color="#ffffff" padding="10px 0 30px" border-radius="8px">
      <mj-column width="100%">
        <mj-text font-size="20px" color="#333333" font-weight="bold" align="center">Time is running out!</mj-text>
        <mj-spacer height="15px" />
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="0 0 30px" border-radius="8px">
      <mj-column width="30%" css-class="countdown-box">
        <mj-text font-size="42px" color="#1890ff" font-weight="bold" align="center" padding-bottom="0">{{days}}</mj-text>
        <mj-text font-size="14px" color="#555555" align="center" padding-top="0">Days</mj-text>
      </mj-column>
      <mj-column width="30%" css-class="countdown-box">
        <mj-text font-size="42px" color="#1890ff" font-weight="bold" align="center" padding-bottom="0">{{hours}}</mj-text>
        <mj-text font-size="14px" color="#555555" align="center" padding-top="0">Hours</mj-text>
      </mj-column>
      <mj-column width="30%" css-class="countdown-box">
        <mj-text font-size="42px" color="#1890ff" font-weight="bold" align="center" padding-bottom="0">{{minutes}}</mj-text>
        <mj-text font-size="14px" color="#555555" align="center" padding-top="0">Minutes</mj-text>
      </mj-column>
    </mj-section>
    
    <!-- What you'll miss section -->
    <mj-section background-color="#ffffff" padding="30px 0" border-radius="8px">
      <mj-column>
        <mj-text font-size="20px" color="#333333" font-weight="bold">What you'll miss:</mj-text>
        <mj-divider border-color="#1890ff" border-width="2px" width="80px" padding-bottom="20px" />
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="0 0 30px" border-radius="8px">
      <mj-column width="48%" css-class="feature-container">
        <mj-image src="https://via.placeholder.com/300x180?text=Feature+1" alt="Feature 1" border-radius="8px 8px 0 0" />
        <mj-text font-size="18px" font-weight="bold" align="center" padding-top="15px">{{benefit_1_title}}</mj-text>
        <mj-text font-size="16px" color="#555555" align="center">{{benefit_1_description}}</mj-text>
      </mj-column>
      <mj-column width="48%" css-class="feature-container">
        <mj-image src="https://via.placeholder.com/300x180?text=Feature+2" alt="Feature 2" border-radius="8px 8px 0 0" />
        <mj-text font-size="18px" font-weight="bold" align="center" padding-top="15px">{{benefit_2_title}}</mj-text>
        <mj-text font-size="16px" color="#555555" align="center">{{benefit_2_description}}</mj-text>
      </mj-column>
    </mj-section>
    
    <!-- Call to action section -->
    <mj-section background-color="#f0f7ff" padding="30px" border-radius="8px">
      <mj-column>
        <mj-text font-size="20px" font-weight="bold" align="center">Ready to take action?</mj-text>
        <mj-text font-size="16px" color="#555555" align="center">
          Complete your {{action_type}} before <span class="highlight-text">{{deadline_date}}</span> to ensure you don't miss out.
        </mj-text>
        <mj-button background-color="#1890ff" color="#ffffff" font-family="Arial, sans-serif" href="{{action_url}}" width="250px" border-radius="4px" font-weight="bold" font-size="16px">
          {{action_button_text}}
        </mj-button>
        <mj-text font-size="14px" color="#777777" align="center" padding-top="10px">
          Need help? Contact our <a href="mailto:support@copilotly.com" style="color: #1890ff; text-decoration: none;">support team</a>.
        </mj-text>
      </mj-column>
    </mj-section>
    
    ${FOOTER_MJML}
  </mj-body>
</mjml>
`;

// Template metadata for the gallery
export default {
  id: "productReminder",
  name: "Product Reminder",
  category: "product",
  description:
    "A compelling reminder email with countdown timer to prompt users to take action before a deadline, emphasizing the benefits they'll miss.",
  features: [
    "Visual countdown timer",
    "Benefit highlights with images",
    "Urgent but friendly tone",
    "Clear call-to-action",
    "Support contact information",
  ],
  subject: "Don't Miss Out: Your Action Needed",
  subTitle: "A quick reminder about your product subscription",
  mjmlTemplate: productReminder,
};
